<template>
  <div v-if="personData" @keyup.enter="setPasswordWithRestoreCode" class="mt-6 p-lg-6 p-3">
    <input
      :value="personData.password"
      @input="updateValues('password')"
      :placeholder="$t('common.welcome_screen.enter_password')"
      ref="passwordInput"
      type="password"
      autocomplete="current-password"
      class="form-control mt-2"
      autofocus>
    <button @click="setPasswordWithRestoreCode" class="btn btn-sm btn-primary mt-2 mt-2 float-right">{{ $t("common.welcome_screen.change_password_and_login") }}<i class="fe fe-arrow-right"></i></button>
  </div>
</template>

<script>
  import { setNewPassword } from '../../../api/authApi';
  import { AuthStepsMixin } from '../mixins/AuthStepsMixin';
  export default {
    name: 'SetNewPassStep',
    mixins: [AuthStepsMixin],
    methods: {
      setPasswordWithRestoreCode: async function () {
        if (this.personData.password.length >= 6) {
          const ok = await setNewPassword(this.personData.restoreCode, this.personData.password);

          ok ? window.location.href = '/calendar' : this.$noty.error('It looks like password is not correct ');
        } else {
          this.$noty.show('Actually, you password should be 6 characters or longer');
        }
      },
    },
  };
</script>
